import { IoMdSearch } from "react-icons/io";
import { IoMdArrowBack } from "react-icons/io";
import playerImage from '../../assets/images/PlayerImage.png';
import '../../assets/css/Chat.css';
import { useEffect, useState } from "react";
import { apiHandler } from "../../assets/api";
import { useSelector } from "react-redux";
import { endpoint } from "../../assets/api/endpoint";
import ChatPerson from "./ChatPerson";
import Layout from "../../layouts/Layout";
import Spinner from "../../components/Spinner";
import { Tooltip } from "react-tooltip";
import profileImg from '../../assets/images/boy.png'
import CustomPagination from "../../components/CustomPagination";
import { useRef } from "react";
import { HashLoader } from "react-spinners";
import { useLocation } from "react-router-dom";


const ChatBox = () => {
    const [chatData, setChatData] = useState([]);
    const { accessToken } = useSelector((state) => state.loginInfo);
    const [chatPerson, setChatPerson] = useState(false);
    const [selecetdChat, setSelectedChat] = useState();
    const [searchQuery, setSearchQuery] = useState("");
    const [lastMessage, setLastMessage] = useState();
    const [filteredChatData, setFilteredChatData] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [loader, setLoader] = useState(false);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const chatListRef = useRef(null);
    const location = useLocation();
    const { isJoinedPage, chatType, ChatId } = location.state || {};


    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        chatListRef.current?.addEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const filteredChat = filteredChatData.find(
            (chat) => chat.chatId === ChatId
        );

        setSelectedChat(filteredChat)
    }, [ChatId])

    const fetchChats = async (pageToFetch = 0) => {
        setLoader(true);
        try {
            const result = await apiHandler({
                url: `${endpoint.GET_CHAT}?page=${pageToFetch}`,
                method: "GET",
                authToken: accessToken?.accessToken,
            });

            if (result?.data?.content) {
                const content = result.data.content;

                setChatData((prev) => [...prev, ...content]);
                setFilteredChatData((prev) => [...prev, ...content]);
                if (pageToFetch === 0 && content.length > 0) {
                    if (ChatId) {
                        const filteredChat = [...result.data.content].find(
                            (chat) => chat.chatId === ChatId

                        );
                        setSelectedChat(filteredChat);
                    } else {
                        setSelectedChat(content[0]);
                    }
                }
                setPage(result.data.currentPage || 0);

                // Check if there's more data to load
                setHasMore(result.data.currentPage + 1 < result.data.totalPages);
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error("Error fetching chat data:", error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        if (accessToken) {
            fetchChats(0);
        }
    }, [accessToken]);


    const onGoToChat = (chat) => {
        setSelectedChat(chat);
        setChatPerson(true);
    };

    const handleScroll = () => {
        const scrollable = chatListRef.current?.scrollHeight - chatListRef.current?.clientHeight;
        const scrolled = chatListRef.current?.scrollTop;

        if (scrolled + 100 >= scrollable && hasMore && !loader) {
            fetchChats(page + 1);
        }
    };

    useEffect(() => {
        const chatListEl = chatListRef.current;
        if (chatListEl) {
            chatListEl.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (chatListEl) {
                chatListEl.removeEventListener("scroll", handleScroll);
            }
        };
    }, [hasMore, loader, page]);

    const getMessage = (message) => {
        setLastMessage(message[message?.length - 1]);
    };

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        if (query === "") {
            setFilteredChatData(chatData);
        } else {
            const filtered = chatData.filter((chat) =>
                chat.chatName.toLowerCase().includes(query)
            );
            setFilteredChatData(filtered);
        }
    };

    return (
        <div className="container" style={{ height: 'calc(100vh - 85px)', display: 'flex', alignItems: 'center', width: '100%', }}>
            {!loader ?
                <div className="row w-100">
                    {(!isMobile || !chatPerson) && (
                        <>
                            <div className="col-lg-3 col-12">
                                <div className="w-100" >
                                    {chatData?.length > 0 && (
                                        <div className="search-player-container pb-3 ps-sm-3 pe-sm-3" ref={chatListRef} style={{ overflowY: 'auto', height: 'calc(100vh - 200px)' }}>
                                            <div className="row p-3 p-sm-2 chat-search-input" style={{  }}>
                                                <h4 className="text-center mt-3">Chat</h4>
                                                <div className="search-box">
                                                    <IoMdSearch className="search-icon" />
                                                    <input
                                                        type="text"
                                                        placeholder="Search"
                                                        className="chat-input"
                                                        value={searchQuery}
                                                        onChange={handleSearch}
                                                    />
                                                </div>
                                            </div>
                                           <div className="ps-3 ps-sm-0 pe-3 pe-sm-0">
                                            {filteredChatData.length > 0 ?
                                                filteredChatData.map((chat) => (
                                                    <div
                                                        className={`row mt-3 mb-3  chat-box-wrapper ${selecetdChat?.chatId === chat.chatId ? 'active-chat' : ''}`}
                                                        key={chat.chatId}
                                                        onClick={() => onGoToChat(chat)}
                                                    >
                                                        <div className="col-4">
                                                            <img
                                                                src={chat?.chatType == 'PRIVATE' && (chat?.chatType.users?.[0].avatarUrl) ? chat?.chatType.users?.[0].avatarUrl : profileImg}
                                                                alt={'IMG'}
                                                                className="chat-person-image"
                                                            />
                                                        </div>
                                                        <div className="col-8">
                                                            <div className="row h-100 d-flex align-items-start">
                                                                <div className="text-start">
                                                                    <div className="chat-title">{chat?.chatType == 'PRIVATE' ? chat?.users?.[0]?.avatarName : chat?.chatName}</div>
                                                                </div>
                                                                {chat?.unreadMessages.length > 0 && (
                                                                    <div className="col-6 text-end d-flex justify-content-end align-items-start">
                                                                        <span className="notification-count">{chat?.unreadMessages}</span>
                                                                    </div>
                                                                )}
                                                                <p className="mt-1" style={{ fontSize: '14px' }} >{(chat?.latestMessage).slice(0, 15)}...</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                                :
                                                <p className="text-center mt-3">No chats available</p>
                                            }
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {chatData?.length === 0 && (
                                <h3 className="text-center mt-3 fs-2 "  style={{fontWeight: '600', color: 'rgba(33, 37, 41, 0.75)'}}>No chats available</h3>
                            )}
                        </>
                    )}
                    {(selecetdChat && (!isMobile || chatPerson)) && (
                        <div className="col-lg-9 col-12 chat-person-tin">
                            {isMobile && (
                                <div className="d-flex align-items-center mb-2" onClick={() => setChatPerson(false)} style={{ cursor: 'pointer' }}>
                                    <IoMdArrowBack size={24} /> <span className="ms-2">Back to chats</span>
                                </div>
                            )}
                            <ChatPerson chatData={selecetdChat} OnMessage={getMessage} />
                        </div>
                    )}
                </div>
                :
                <div className="d-flex align-items-center justify-content-center w-100" style={{ height: '55vh' }}>
                    < HashLoader color="#e48181" />
                </div>
            }
        </div>
    );
};

export default ChatBox;
